export interface IDBMessage {
    messageId?: number;
    userId: number;
    tlChatId: number;
    tlMessageId: number;
    contactId: number;
    body?: string;
    originBody?: string;
    date?: string | null;
    time?: string | null;
    soTin?: string | null;
    type?: number | null;
    md5ContentChecksum?: string | null;
    mienCuPhapId: number;
    textChecksum?: string | null;
    dataChecksum?: string | null;
    tinhId?: string | null;
}

export function DBMessageDefault(): IDBMessage {
    return {
        userId: 0,
        tlChatId: 0,
        tlMessageId: 0,
        contactId: 0,
        mienCuPhapId: 0,
        body: "",
        originBody: "",
        date: null,
        time: null,
        soTin: null,
        type: null,
        md5ContentChecksum: null,
        textChecksum: null,
        dataChecksum: null,
        tinhId: null
    };
}